import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  connect() {
    // Hide flash messages after 5 seconds
    setTimeout(() => {
      this.element.remove()
    }, 5000)
  }
}

